import * as React from 'react'
import './AlertStateTags.css'

export const alertStates = {
  alerting: {clazz: 'alerting', label: 'Alerting'},
  ok: {clazz: 'ok', label: 'OK'},
  paused: {clazz: 'paused', label: 'Paused'},
  no_data: {clazz: 'noData', label: 'No Data'},
  pending: {clazz: 'pending', label: 'Pending'}
}

export type ValueProps = {
  name: string
  testId?: string
}

export type EventProps = {}

export type Props = ValueProps & EventProps

class AlertStateTag extends React.Component<Props, {}> {
  
  render() {
    const {name, testId} = this.props
    const alert = alertStates[name.toLowerCase()]
    
    if (!alert) {
      return false
    }
    
    return (
      <div className={'state-tag-container'} data-test-id={testId}>
        <span className={`stateTag ${alert.clazz}`}>{alert.label}</span>
      </div>
    )
  }
}

export default AlertStateTag
